export const SecurityGroupCode = {
    Shopping: "SHOPPING",
    ShoppingGroup: "SHOPPINGGROUP"
}